import { createTelemetryEvent } from "../../telemetry/Telemetry";
import { telemetryChannelName, testNetworkSpeedSettings } from "../../util/constants";

export const featureName = "playback";
export const networkSpeedTestType = "networkSpeedTest";

export const NetworkSpeedTest = () => {
  const testNetworkSpeed = async () => {
    const startTime = new Date().getTime();
    const testPath = `${testNetworkSpeedSettings.testFilePath}?timestamp=${startTime}`;
    const dataTestFile = await fetch(testPath);
    const dataTestFileBlob = await dataTestFile.blob();
    const endTime = new Date().getTime();

    const duration = (endTime - startTime) / 1000;
    const bitsLoaded = dataTestFileBlob.size * 8;
    const speedBps = bitsLoaded / duration;
    const speedKbps = speedBps / 1024;
    const speedMbps = speedKbps / 1024;

    const networkSpeedData = {
      testPath,
      timestamp: startTime,
      mbps: parseFloat(speedMbps.toFixed(2)),
    };

    await setNetworkSpeed(networkSpeedData);

    createTelemetryEvent({
      feature: featureName,
      action: "network speed test",
      action_meta: `test path: ${testPath}`,
    }).fire(telemetryChannelName);
  };

  const setNetworkSpeed = async (networkSpeedData: { testPath: string; timestamp: number; mbps: number }) => {
    localStorage.setItem("NETWORK_SPEED", JSON.stringify(networkSpeedData));
  };

  const getNetworkSpeed = async () => {
    const networkSpeedData = localStorage.getItem("NETWORK_SPEED");
    return networkSpeedData ? JSON.parse(networkSpeedData) : undefined;
  };

  const getAndMaybeTestNetworkSpeed = async () => {
    let networkSpeed = await getNetworkSpeed();

    const staleTest =
      Date.now() - (networkSpeed?.timestamp ?? Date.now()) >=
      testNetworkSpeedSettings.networkSpeedCheckMinMinutes * 60 * 1000;

    if (!networkSpeed || staleTest) {
      await testNetworkSpeed();
      networkSpeed = await getNetworkSpeed();
    }

    return networkSpeed;
  };

  return {
    testNetworkSpeed,
    setNetworkSpeed,
    getNetworkSpeed,
    getAndMaybeTestNetworkSpeed,
  };
};
